/**
 * Created by yuxin.zhang on 2017/11/7.
 */

function getPageLink(root, account, balance) {
  return {
    // 再kyc认证
    reVerification: `${account}/reVerification`,
    // 资金密码
    bindBankCard: `${account}/bindBankCard`,
    checkAddress: `${account}/checkAddress`,
    modifyWithdrawLimit: `${account}/bindWithdrawLimit`,
    registerSuccess: `${root}/registerSuccess`,
    cashDeposit: `${balance}/wallet/cashDeposit`,
    cashWithdraw: `${balance}/wallet/cashWithdraw`,
    cashWithdrawDetail: `${balance}/wallet/cashWithdraw/withdrawDetail`,
    edd: `${account}/edd`,
    carfForm: `${account}/carfForm`,
  };
}

export default getPageLink;
